import { useQuery } from '@tanstack/react-query';

import { billingInfoRepo } from '@ctct/domain-layer';

import { QueryKeys } from './constants';
import { useQueryMemoized } from '../helpers/useQueryMemoized';

export const useBillingInfo = () => {
  const query = useQuery({
    queryKey: [QueryKeys.BILLING_INFO],
    queryFn: () => billingInfoRepo.getBillingInfo(),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  return useQueryMemoized(query);
};

export type UseBillingInfo = ReturnType<typeof useBillingInfo>;
